import * as React from 'react'

import { BIBME, CHEGG, CITATION_MACHINE, SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import CheggHeader from './CheggHeader'
import LeftSide from './LeftSide'
import RightSide from './RightSide'

const BaseHeader = styled.header`
  width: 100%;
  min-height: 52px;
  height: 52px;
  font-size: ${({ theme }) => theme.font.text.size.xs};
  font-weight: normal;
  position: relative;
  display: flex;
  border-bottom: 1px solid ${props => props.theme.colors.greyXlight};
  overflow: visible;
`

interface StateProps {
  site: SiteState
}

type Props = StateProps

const EasyBibHeader = styled(BaseHeader)`
  background-color: ${({ theme }) => theme.colors.white};
`
const BibMeHeader = styled(BaseHeader)`
  background-color: ${({ theme }) => theme.colors.BMBlue};
`

const CitationsHeader = styled(BaseHeader)`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 4px solid ${props => props.theme.colors.CMRed};
`

export const Header: React.FunctionComponent<Props> = ({ site, ...props }) => {
  switch (site) {
    case BIBME:
      return <BibMeHeader {...props} />
    case CITATION_MACHINE:
      return <CitationsHeader {...props} />
    case CHEGG:
      return <CheggHeader />
    default:
      return <EasyBibHeader {...props} />
  }
}

const mapStateToProps = (state: RootState) => ({
  site: state.site,
})

const ConnectedHeader = connect<StateProps>(mapStateToProps)(Header)

const SiteHeader = () => (
  <ConnectedHeader>
    <LeftSide />
    <RightSide />
  </ConnectedHeader>
)

export default SiteHeader



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx